import {api} from '@/libs/baseApi.client';

export interface CelebrityShareResponse {
  shareUrl: string;
  shareText: string;
  imageUrl: string;
  reward: {
    poe: number;
    coins: number;
  };
  isFirstTime: boolean;
}

/**
 * Initiates share of celebrity auctions page.
 * Rewards are awarded on first share per celebrity.
 * Card requires 3+ active auctions.
 */
export const shareCelebrity = async (celebrityId: number): Promise<CelebrityShareResponse> => {
  const response = await api.post<CelebrityShareResponse>(`/platform-actions/celebrity-share/${celebrityId}`);
  return response.data;
};
